import type { IconSvgObject } from './types';

const BorderNone01Icon: IconSvgObject = [
  ["path", { d: "M2.5 13.5V9.5M21.5 9.5V13.5M21.5 5.75V5C21.5 3.34315 20.1569 2 18.5 2H17.75M10 2H14M6.25 2H5.5C3.84315 2 2.5 3.34315 2.5 5V5.75M21.5 17.25V18C21.5 19.6569 20.1569 21 18.5 21H17.75M10 21H14M6.25 21H5.5C3.84315 21 2.5 19.6569 2.5 18V17.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2V3.9M12 19.1V21M9.15 11.5H14.85M19.6 11.5H21.5M2.5 11.5H4.4M12 8.64999V14.35", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BorderNone01Icon;
